import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { AuditReportFilters } from '../interfaces/audit-report-filters.interface';

@Injectable({
  providedIn: 'root',
})
export class AuditReportService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.auditReportApiBaseUrl}/generate-report-file/excel/audit`;

  downloadAuditReport(filters: AuditReportFilters): Observable<HttpResponse<Blob>> {
    const params = this.buildParams(filters);

    return this.http.get(this.endpoint, {
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }

  private buildParams(filters: AuditReportFilters): HttpParams {
    let params = new HttpParams();

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        params = params.set(key, String(value).trim());
      }
    }

    return params;
  }
}
